











import {IFilterItem} from '../../models/filter-item-model';
import Checkbox from './Checkbox.vue'
import {defineComponent, PropType} from "@vue/composition-api";

export default defineComponent({
  name: 'CheckboxList',
  components: {
    Checkbox
  },
  props: {
    filters: {type: Array as PropType<IFilterItem[]>}
  }
})
